import React from 'react';
import logo from "BaseLayout/assets/img/logos/logo_tudo.svg";

/** @jsx jsx */
import { jsx } from 'theme-ui';
export const TudoLogo = (): React.JSX.Element => {
    return <img  sx={{width: "15em"}} src={logo} />;
};
